// eslint-disable-next-line import/prefer-default-export
export function initFixedHeader() {
  const headerBlock = document.querySelector('.hdr');
  if (!headerBlock) return;
  const changeHeader = (entries) => {
    headerBlock.classList.toggle('is-sticky', !entries[0].isIntersecting);
  };
  const TransitHeader = (entries) => {
    headerBlock.classList.toggle('is-transit', !entries[0].isIntersecting);
  };
  const activateHeader = (entries) => {
    headerBlock.classList.toggle('is-visible', !entries[0].isIntersecting);
  };
  const observer = new IntersectionObserver(changeHeader, {
    rootMargin: '100px',
    threshold: 1.0,
  });
  const twoObserver = new IntersectionObserver(TransitHeader, {
    rootMargin: '150px',
    threshold: 1.0,
  });
  const threeObserver = new IntersectionObserver(activateHeader, {
    rootMargin: '200px',
    threshold: 1.0,
  });
  observer.observe(headerBlock);
  twoObserver.observe(headerBlock);
  threeObserver.observe(headerBlock);
}
